// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-query-left-nav{height:auto;background:#fff;box-shadow:0 0 4px 0 rgba(0,0,0,.08),0 2px 6px 0 rgba(0,0,0,.08)}.history-query-left-nav .master_nav__label{margin:0}.history-query-left-nav .master_nav-item__wrap svg[icon*=ProductsEurekaInsights],.history-query-left-nav .master_nav-item__wrap svg[icon*=SolidCoreProductsDiscovery]{font-size:19px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
